import { useRecoilValue } from 'recoil'

import { $sitemap, $sitemapItems } from './selectors'

export function useSitemap(sitemapName: string) {
  const sitemap = useRecoilValue($sitemap(sitemapName))
  return sitemap
}

export function useSitemapItems() {
  const items = useRecoilValue($sitemapItems)
  return items
}
